// web/index.web.js
// MUST be first - aggressive bind polyfill
if (!Function.prototype.bind) {
  Function.prototype.bind = function(oThis) {
    if (typeof this !== 'function') {
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }
    var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function() {},
        fBound = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };
    if (this.prototype) {
      fNOP.prototype = this.prototype; 
    }
    fBound.prototype = new fNOP();
    return fBound;
  };
}

import { AppRegistry } from "react-native";
import "../src/i18n";
import App from "../App.tsx";
import { name as appName } from "../app.json";
// Import MaterialIcons font
import "react-native-vector-icons/Fonts/MaterialIcons.ttf";
// Import Inter custom fonts for web
import "../src/assets/fonts/Inter/web/inter-custom.css";
// Initialize AppDynamics Browser RUM for web - aligned with mobile configuration
import "./appDynamicsInit.js";
// Import SVG polyfill to fix react-native-svg issues on web
import "./svgPolyfill.js";

// ── Deep Linking: Handle direct ticket URLs ──
const parseTicketUrl = () => {
  const path = window.location.pathname;
  // Match URLs like /ticket-details/ticket-id/NTI-2026-02598
  const ticketMatch = path.match(/\/ticket-details\/ticket-id\/([A-Z0-9\-]+)/);
  if (ticketMatch && ticketMatch[1]) {
    return {
      screen: "Ticket Detail",
      ticketId: ticketMatch[1],
    };
  }
  return null;
};

// ── Deep Linking: Handle direct notification URLs (e.g. Teams "View Details") ──
const parseNotificationUrl = () => {
  const path = window.location.pathname;
  // Match URLs like /notification-details/notification-id/12345
  const notifMatch = path.match(/\/notification-details\/notification-id\/([A-Za-z0-9\-]+)/);
  if (notifMatch && notifMatch[1]) {
    return {
      screen: "Ticketing Portal",
      notificationId: notifMatch[1],
    };
  }
  return null;
};

const initialRoute = parseTicketUrl() || parseNotificationUrl();
const initialProps = initialRoute
  ? initialRoute.ticketId
    ? { initialRoute: initialRoute.screen, ticketId: initialRoute.ticketId }
    : { initialRoute: initialRoute.screen, notificationId: initialRoute.notificationId }
  : {};

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  initialProps,
  rootTag: document.getElementById("root"),
});

